import { getRequiredMessage, getFieldValidator } from './formUtils'

/*
 * This function Return a message that is used to the Formik form as
 * a error message.
 *
 * will return a error message if the user doesn't write anything inside the fields
 * or write uncomplete or unformmat information.
 *
 * @param [Object] field object is an object that has important data about each form field
 * @param [String] fieldType the type of the field it can be either ssn, offercode etc
 *
 * @return [String]
 */

export function getDefaultValidator(field) {
  const validationErrorResult = value => {
    let errorMessage
    if (value === '' || !value) {
      errorMessage = getRequiredMessage(field)
    }
    return errorMessage
  }
  return validationErrorResult
}

export function stringValidator(field, fieldType) {
  const { regex, error } = getFieldValidator(field.fieldLabel, fieldType) || {}
  const validationErrorResult = value => {
    let errorMesage

    if (field.fieldLabel !== 'Unit') {
      if (value === '' || !value) {
        errorMesage = getRequiredMessage(field)
      } else if (!regex.test(value)) {
        errorMesage = error
      }
    }

    return errorMesage
  }

  return validationErrorResult
}

export function validateStringField(fieldName, fieldType, value) {
  const { regex, error } = getFieldValidator(fieldName, fieldType)
  let errorMesage = ''
  if (!regex.test(value)) {
    errorMesage = error
  }
  return errorMesage
}
